import { Outlet } from 'react-router-dom'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useLocations } from 'modules/locations/hooks/useLocations'
import BookingsDatatable from 'modules/space_control/components/BookingsDatatable'

const BookingsPage = () => {
  useEffect(() => {
    track(trackingEvents.spaceControl.seeBookings)
  }, [])

  const { loading, locations, error } = useLocations()
  return (
    <ResponsivePage.Body loading={loading} showHeader={false} error={error}>
      <BookingsDatatable locations={locations} />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default BookingsPage
